import { render, staticRenderFns } from "./WriterPreferences.vue?vue&type=template&id=f2267f84&"
import script from "./WriterPreferences.vue?vue&type=script&lang=js&"
export * from "./WriterPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports